export const REMOVE_RECENTLY_VISITED_ITEM = 'REMOVE_RECENTLY_VISITED_ITEM';
export const LOAD_RECENTLY_VISITED = 'LOAD_RECENTLY_VISITED';

export const removeRecentlyVisitedItem = (id: string | number) =>
  ({ type: REMOVE_RECENTLY_VISITED_ITEM, id } as const);

export const loadRecentlyVisited = () =>
  ({ type: LOAD_RECENTLY_VISITED } as const);
